"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackGAEvent = void 0;

var trackGAEvent = function trackGAEvent(category, type, values, isAuth) {
  // google analytics
  if (window.gtag) {
    gtag('event', "".concat(category, "-").concat(type, " - ").concat(values, ";").concat(typeof isAuth !== 'undefined' ? " isAuth:".concat(isAuth) : ''), {
      event_category: category
    });
  }
};

exports.trackGAEvent = trackGAEvent;